import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  createCurrentIdStore,
  CurrentIdStore,
} from '../helpers/createCurrentIdStore';

const FIELD_NAME = 'projectId';

export type CurrentProjectIdContextStore = CurrentIdStore<
  typeof FIELD_NAME,
  string
>;

export const useCurrentProjectIdStore = createCurrentIdStore<
  typeof FIELD_NAME,
  string
>({
  contextName: CONTEXT_NAMES.CurrentProjectIdContext,
  fieldName: FIELD_NAME,
});
